import { AppPageComponent } from '../shared/ui/app-page/app-page.component';
import { TopLevelComponent } from '../shared/models';
import { Store, StoreHelper, UserService } from '../shared/services';
import { Notification, PushNotification } from './shared/models';
import { Subscription } from 'rxjs';
import { NotificationService } from './shared/services/notifications.service';
import { Component, ViewChild, OnInit, OnDestroy } from '@angular/core';

@Component({
    template: require('./notifications.component.pug'),
    styles: [ require('./notifications.component.scss')]
})
export class NotificationsComponent extends TopLevelComponent implements OnInit, OnDestroy {
    @ViewChild(AppPageComponent) appPage;

    notificationSub: Subscription;
    pushNotificationSub: Subscription;

    notifications: Notification[] = [];
    pushNotifications: PushNotification[] = [];

    error: string = '';

    elementsLoaded = { system: false, push: false };

    constructor(store: Store,
                storeHelper: StoreHelper,
                userService: UserService,
                private notificationService: NotificationService) {
        super(store, storeHelper, userService);
        this.headerTitle = 'Notifications';
        this.headerActions = [{ id: 'none', icon: 'none' }];
    }

    ngOnInit() {
        let that = this;

        this.pushNotificationSub = this.notificationService.getPushNotifications()
            .subscribe(
                n => this.pushNotifications = n,
                err => this.error = err,
                () => that.notifyElementLoaded('push')
            );

        this.notificationSub = this.notificationService.getSystemNotifications()
            .subscribe(
                n => this.notifications = n,
                err => this.error = err,
                () => that.notifyElementLoaded('system')
            );
    }

    ngOnDestroy() {
        this.notificationSub.unsubscribe();
        this.pushNotificationSub.unsubscribe();
    }

    notifyElementLoaded(element: string = null) {
        if (!element)  { return; };

        switch (element) {
                case 'system':
                    this.elementsLoaded.system = true;
                    if (this.elementsLoaded.push === true && this.elementsLoaded.system === true) {
                        this.appPage.deactivatePreloader();
                    }
                    break;
                case 'push':
                     this.elementsLoaded.push = true;
                    if (this.elementsLoaded.push === true && this.elementsLoaded.system === true) {
                        this.appPage.deactivatePreloader();
                    }
                    break;
        }

    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/notifications/notifications.component.ts